import React, { useEffect } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Grid } from 'react-md'

import { handleSubmit, Input } from 'components/form'
import { Modal } from 'components/core'

import { defaultValues, validationSchema } from './config'
import { handleSave } from './actions'

interface ComponentProps {
  maintenanceScheduleId: string
  actionId: string | null | undefined
  maintenanceAction: any | null
  visibleModal: boolean
  disableModal: () => void
  loadMaintenanceSchedule: () => Promise<void>
  onHide: () => void
}

const Component: React.FC<ComponentProps> = ({
  maintenanceScheduleId,
  actionId,
  maintenanceAction,
  visibleModal,
  disableModal,
  loadMaintenanceSchedule,
  onHide,
}) => {
  const form = useForm({ defaultValues })

  useEffect(() => {
    if (maintenanceAction) form.reset({ description: maintenanceAction.description }, { dirty: false })
  }, [maintenanceAction])

  return (
    <Modal
      width={500}
      title={'Atualização de Ação de Manutenção'}
      visible={visibleModal}
      confirmTitle={'Salvar'}
      confirmDisabled={!form.formState.dirty}
      confirmAction={async () => {
        await handleSubmit(form, validationSchema, async () => {
          await handleSave({ maintenanceScheduleId, id: actionId, ...form.getValues() })
          form.reset(defaultValues, { dirty: false })
          await loadMaintenanceSchedule()
          onHide()
          disableModal()
        })
      }}
      closeTitle={'Fechar'}
      closeAction={async () => {
        form.reset(defaultValues, { dirty: false })
        onHide()
        disableModal()
      }}>
      <Grid>
        <FormContext {...form}>
          <Input name='description' label='Descrição *' desktopSize={12} tabletSize={8} />
        </FormContext>
      </Grid>
    </Modal>
  )
}

export default Component
